import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker with auto-update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', {
      updateViaCache: 'none' // Never use cached service worker
    }).then((registration) => {
      // Check for updates every 60 seconds
      setInterval(() => registration.update(), 60 * 1000);

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'activated') {
            // New version available, reload to use it
            window.location.reload();
          }
        });
      });
    }).catch((error) => {
      console.log('SW registration failed:', error);
    });
  });
}
